import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { lazy } from 'utils/generic/lazy';
import { getRecaptchaEnabled } from 'store/selectors/app-data';

const { DoBetRecaptchaComponent } = lazy(
  () => import(/* webpackChunkName: "recaptcha" */ './Component')
);

export const DoBetRecaptcha = () => {
  const recaptchaEnabled = useSelector(getRecaptchaEnabled);

  return recaptchaEnabled ? (
    <Suspense>
      <DoBetRecaptchaComponent />
    </Suspense>
  ) : null;
};
